import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const categories = [
  {
    id: 'mattresses',
    name: 'Mattresses',
    description: '70+ premium options',
    brands: 'Eclipse, Sleepwell, King Koil, Kurlon',
    image: '/category-images/mattresses.png',
    featured: true,
  },
  {
    id: 'pillows',
    name: 'Pillows & Cushions',
    description: '25+ comfort choices',
    brands: 'Memory Foam, Micro Fiber, PU Foam',
    image: '/category-images/pillows.png',
    featured: false,
  },
  {
    id: 'bedsheets',
    name: 'Bedsheets',
    description: '30+ elegant designs',
    brands: 'myTrident, Bombay Dyeing, Calvin',
    image: '/category-images/bedsheets.png',
    featured: false,
  },
  {
    id: 'towels',
    name: 'Towels',
    description: 'Bath, Hand, Face & Kitchen',
    brands: 'myTrident, Bombay Dyeing',
    image: '/category-images/towels.png',
    featured: false,
  },
  {
    id: 'blankets',
    name: 'Blankets & Comforters',
    description: 'Blankets, Dohars & more',
    brands: 'Signature, Golden UNO',
    image: '/category-images/blankets.png',
    featured: false,
  },
  {
    id: 'mats',
    name: 'All Mats',
    description: 'Door, Bath, Shower, Yoga & Table',
    brands: 'Various brands',
    image: '/category-images/mats.png',
    featured: false,
  },
];

export const Categories = () => {
  return (
    <section 
      data-testid="categories-section"
      className="py-16 md:py-24 bg-[#FDFBF7]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <p className="text-sm font-medium tracking-widest uppercase text-teal-700 mb-3">
            Our Collections
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-stone-800 mb-4">
            Explore Product Categories
          </h2>
          <p className="text-lg text-stone-600 max-w-2xl mx-auto">
            From premium mattresses to elegant bedding, find everything for your perfect sleep
          </p>
        </div>

        {/* Bento Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {categories.map((category, index) => (
            <Link
              key={category.id}
              to={`/products?category=${category.id}`}
              data-testid={`category-card-${category.id}`}
              className={`group relative overflow-hidden rounded-2xl cursor-pointer ${
                category.featured 
                  ? 'md:col-span-2 md:row-span-2 aspect-square md:aspect-auto' 
                  : 'aspect-[4/5]'
              }`}
            >
              {/* Background Image */}
              <img 
                src={category.image}
                alt={category.name}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              
              {/* Gradient Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />
              
              {/* Content */}
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <h3 className={`font-bold text-white mb-1 ${
                  category.featured ? 'text-2xl md:text-3xl' : 'text-xl md:text-2xl'
                }`}>
                  {category.name}
                </h3>
                <p className="text-white/80 text-sm mb-2">{category.description}</p>
                <p className="text-teal-300 text-xs">{category.brands}</p>
                
                {/* Arrow on hover */}
                <div className="flex items-center gap-2 mt-4 text-white opacity-0 group-hover:opacity-100 transition-opacity">
                  <span className="text-sm font-medium">View Collection</span>
                  <ArrowRight className="w-4 h-4" />
                </div>
              </div>

              {/* Featured Badge */}
              {category.featured && (
                <div className="absolute top-4 left-4 bg-amber-500 text-white text-xs font-semibold px-3 py-1 rounded-full">
                  Most Popular
                </div>
              )}
            </Link>
          ))}
        </div>

        {/* View All Button */}
        <div className="text-center mt-10">
          <Link 
            to="/products"
            data-testid="view-all-products-btn"
            className="inline-flex items-center gap-2 text-teal-700 hover:text-teal-800 font-semibold text-lg transition-colors"
          >
            View All Products
            <ArrowRight className="w-5 h-5" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Categories;
